var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview-page"},[_c('div',{staticClass:"preview-page-body"},[_c('iframe',{staticClass:"match-height match-width",attrs:{"id":"iframe","src":"https://h5.cdn.bjadks.com/website/lvzhengcaovr/index.html","frameborder":"no"}})])])
}]

export { render, staticRenderFns }